<template>
	<el-card>
		<div slot="header">
			<span class="top_title">客户详情</span>
		</div>
		<div class="searchItem">
			<div class="search">
				<span class="searchtips">客户编号:</span>
				<el-input v-model="search.cnumber" style="width:140px" placeholder="输入客户编号" @keyup.enter.native="searchData()" />
			</div>
			<div class="search">
				<span class="searchtips">客户名称:</span>
				<el-input v-model="search.cname" style="width:140px" placeholder="输入客户名称" @keyup.enter.native="searchData()" />
			</div>
			<div class="search" v-if="stateList.length>0">
				<span class="searchtips">客户状态:</span>
				<el-select v-model="search.state" style="width:140px" placeholder="请选择" @change="searchData()" clearable>
					<el-option v-for="(item,index) in stateList" :key="index" :label="item" :value="item"></el-option>
				</el-select>
			</div>
			<div class="search">
				<el-button @click="advancedDialog=true">高级搜索</el-button>
			</div>
			<div class="search">
				<el-button type="primary" @click="searchData()" icon="el-icon-search">查询</el-button>
			</div>
		</div>
		<div style="display:flex;justify-content: space-between;padding-bottom: 20px;position: relative;">
			<el-button @click="colsDialog = !colsDialog">
				列设置
			</el-button>
			<div>
				<el-button split-button type="primary" @click="addCus" v-if="$common.hasLimits('customerAdd')">新增客户</el-button>
				<el-dropdown @command="doAction" style="margin-left:10px">
					<el-button type="primary">
						<i class="el-icon-menu"></i><span>操作</span>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="0">禁用</el-dropdown-item>
						<el-dropdown-item command="1">启用</el-dropdown-item>
						<el-dropdown-item command="2" v-if="$common.hasLimits('customerDelete')">删除</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<el-table v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;margin-bottom: 20px;" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55" align="center" />
			<el-table-column label="操作" width="120" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="handleEdit(scope.row)"  v-if="$common.hasLimits('customerEdit')">编辑</el-button>
					<el-button type="text" @click="handleDelete(scope.row)" v-if="$common.hasLimits('customerDelete')">删除</el-button>
				</template>
			</el-table-column>
			<template v-for="(col, index) in cols">
				<el-table-column v-if="col.show" :key="index" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align"  show-overflow-tooltip>
					<template #header v-if="col.column">
						{{col.label}}
						<el-button circle icon="el-icon-top" size="mini" v-if="search.column==col.column&&search.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-if="search.column==col.column&&search.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
					</template>
					<template  slot-scope="{row}">
						<template v-if="col.type=='remark'">
							<div class="uni_ellipsis">{{row[col.prop]}}</div>
						</template>
						<template v-else>{{row[col.prop]}}</template>
					</template>
				</el-table-column>
			</template>
			<el-table-column label="状态" width="70" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.valid" :active-value="1" :inactive-value="0" @change="enableDisable(scope.row)" />
				</template>
			</el-table-column>
		</el-table>

		<el-pagination  style="text-align: right;" :page-sizes="page.limits" :page-size="page.limit" layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="5"/>
		<el-dialog :visible.sync="colsDialog" title="列设置" width="60%">
			<column-edit :cols="cols"/>
			<div slot="footer" class="dialog-footer">
				<el-button type="text" @click="cols = initCols();" style="float:left">恢复默认设置</el-button>
				<el-button type="primary" @click="saveCols()">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="高级搜索" :visible.sync="advancedDialog" width="60%">
			<el-form ref="advanceform" :inline="true" :model="search" class="demo-form-inline" label-width="100px">
				<el-form-item label="客户编号">
					<el-input v-model="search.cnumber" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="客户名称">
					<el-input v-model="search.cname" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="客户类别">
					<el-cascader v-model="search.category" :props="{ checkStrictly: true,value:'id' }" :options="options" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="电话">
					<el-input v-model="search.phone" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="联系人">
					<el-input v-model="search.contactname" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="联系人手机">
					<el-input v-model="search.contactphone" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="指定货运">
					<el-input v-model="search.transport" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="search.remark" placeholder="" style="width: 160px;" />
				</el-form-item>
				<el-form-item label="状态">
					<el-select ref="state" v-model="search.valid" placeholder="请选择" style="width: 160px;">
						<el-option v-for="(item , index) in validOptions" :key="index" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item style="display: block;text-align: center;">
					<el-button @click="resetForm">重置</el-button>
					<el-button type="primary" @click="searchData">
						查询
					</el-button>
					<el-button @click="advancedDialog=false">
						取消
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="编辑客户" :visible.sync="editDialog" width="90%">
			<customer-edit ref="edit" :cid="cid" style="height: 450px;overflow: auto" @closeEdit="closeEdit" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editConfirm">确认</el-button>
				<el-button @click="editDialog = false">取消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="新增客户" :visible.sync="addDialog" width="90%">
			<customer-add ref="add" style="height: 450px;overflow: auto" @close="close" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" throttle @click="addClose">保存并关闭</el-button>
				<el-button @click="addDialog = false">取消</el-button>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
	import CustomerEdit from '@/components/customer/edit'
	import CustomerAdd from '@/components/customer/add'
	import ColumnEdit from '@/components/table-column/Column'
	export default {
	components: {
		ColumnEdit,
		CustomerEdit,
		CustomerAdd
	},
		data() {
			return {
				cols: [],
				colsDialog: false,
				editDialog: false,
				addDialog: false,
				cid: 0,
				loading: true,
				search: {
					cnumber: '',
					cname: '',
					category:[],
					phone: '',
					contactname: '',
					contactphone: '',
					transport: '',
					transportId:'',
					remark: '',
					valid: '',
					column:'',
					order:'',
					state:'',
				},
				validOptions: [{
					value: '',
					label: '全部'
				}, {
					value: 1,
					label: '启用'
				}, {
					value: '0',
					label: '禁用'
				}],
				options: [],
				tableData: [],
				multipleSelection: [],
				stateList:[],
				dialogFormVisible: false,
				advancedDialog: false,
				page: {
					current: 1,
					total: 0,
					limit: 20,
					limits: [20, 50, 120, 250]
				},
				searchObj:{
					page: 1,
					limit: 20,
				},
				
			}
		},
		mounted() {
			this.getData();
			this.getCategory();
			this.$api.getCustomerState({page:1,limit:-1}).then(res=>{
					this.stateList = [];
					let arr = res.data.data.customer_state;
					if(arr&&arr.length>0){
						arr.forEach(e=>{
							this.stateList.push(e.label);
						})
					}
				})
			this.$api.getTableCols({tableName: 'ipad_customer'}).then(res=>{
				if(res.data.code==1){
					let obj = res.data.data;
					if(obj.cols){
						let arr = this.initCols();
                        obj.cols.forEach(e=>{
                            let prop = e.prop;
                            let show = e.show;
                            for(let i in arr){
                                if(arr[i].prop==prop){
                                    let target = arr.splice(i,1);
                                    target[0].show = show;
                                    this.cols.push(target[0]);
                                    break;
                                }
                            }
                        })
                        if(arr.length>0){
                            this.cols.push(...arr);
                        }
					}else{
						this.cols = this.initCols();
					}
				}else{
					this.cols = this.initCols();
				}
			})
			
		},
		methods: {
			initCols(){
				let arr = [{
						prop: 'category',
						label: '客户类别',
						edit: '',
						type: '',
						show: true,
						width: 110
					},
					{
						prop: 'rank',
						label: '客户等级',
						edit: '',
						type: '',
						show: true,
						width: 110
					},
					{
						prop: 'cnumber',
						label: '编号',
						edit: '',
						type: '',
						show: true,
						width: 140,
					},
					{
						prop: 'cname',
						label: '客户名称',
						edit: '',
						type: '',
						show: true,
						width: 220,
						column:'name'
					},
					{
						prop: 'state',
						label: '客户状态',
						edit: '',
						type: '',
						show: true,
						width: 140,
					},
					{
						prop: 'phone',
						label: '电话',
						edit: '',
						type: '',
						show: true,
						width: 120
					},
					{
						prop: 'empName',
						label: '销售人员',
						edit: '',
						type: '',
						show: true,
						width: 110
					},
					{
						prop: 'contactname',
						label: '联系人',
						edit: '',
						type: '',
						show: true,
						width: 110
					},

					{
						prop: 'bill',
						label: '应收款余额(元)',
						edit: '',
						type: '',
						show: true,
						width: 120,
					},
					{
						prop: 'trans',
						label: '送货地址',
						edit: '',
						type: 'remark',
						show: true,
					},
					{
						prop: 'remark',
						label: '备注',
						edit: '',
						type: 'remark',
						show: true
					}
				]
				return arr;
			},
			saveCols(){
				let obj = {
					tableName:'ipad_customer',
					data:JSON.stringify(this.cols),
				}
				this.$api.setTableCols(obj).then(res=>{
					if(res.data.code==1){
						this.$notify({
							title: "列设置",
							message: "修改成功",
							type: "success",
							duration: 2000,
						});
					}
				})
            	this.colsDialog = false;
        	},
			searchData() {
				this.page.current=1;
				this.advancedDialog = false;
				this.searchObj = {
					page: this.page.current,
					limit: this.page.limit,
					...this.search
				}
				let len = this.searchObj.category.length;
				this.searchObj.category=len>0?this.searchObj.category[len-1]:'';
				this.getData();
			},
			setSort(column,order){
				if(this.search.column==column&&this.search.order==order){
					this.search.column = '';
					this.search.order = '';
				}else{
					this.search.column = column;
					this.search.order = order;
				}
				this.sortTime();
			},
			sortTime(){
				if(this.search.column){
					this.searchObj.column = this.search.column;
					this.searchObj.order = this.search.order?'asc':'desc';
				}else{
					delete this.searchObj.column;
					delete this.searchObj.order;
				}
				this.getData();
			},
			getCategory() {
				this.$api.customergetCustomerClassify({}).then(res => {
					if(res.data.code==1){
						this.options = res.data.data;
					}
				}, () => {})
			},
			getData() {
				this.loading = true;
				this.$api.customerlistCustomer(this.searchObj).then(res => {
					if(res.data.code==1){
						this.tableData = [];
						let data = res.data.data;
						if(data!=null&&data.length>0){
							data.forEach(e => {
								if(e.contact.length>0){
									let index = 0;
									for(let i in e.contact){
										if(e.contact[i].main==1){
											index = i;
											break;
										}
									}
									e.trans = e.contact[index].district.join("")+e.contact[index].address;
								}else{
									e.trans = "";
								}
								this.tableData.push(e);
							});
						}
						this.page.total = res.data.count;
					}
					this.loading = false;
				}, () => {
					this.loading = false;
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			},
			handleEdit(row) {
				if(!this.$common.checkLimits("customerEdit")){
					return;
				}
				this.cid = row.id
				this.editDialog = true
				this.$nextTick(() => {
					this.$refs.edit.getType()
				})
			},
			handleDelete(row) {
				if(!this.$common.checkLimits("customerDelete")){
					return;
				}
				const confirmText = ['是否将此项删除？', '注意：删除后不可恢复。']
				const newData = []
				const h = this.$createElement
				for(const i in confirmText) {
					newData.push(h('p', null, confirmText[i]))
				}
				this.$confirm('警告', {
					title: '警告',
					message: h('div', null, newData),
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.customerdeleteCustomer({
						deleteIds: row.id
					}).then(res => {
						this.$notify({
							title: '删除客户',
							message: '删除成功',
							type: 'success',
							duration: 1000,
							onClose: () => {
								this.searchData()
							}
						})
					})
				}, () => {})
			},
			handleSizeChange(val) {
				this.page.limit = val;
				this.searchData();
			},
			handleCurrentChange(val) {
				this.page.current = val;
				this.searchObj.page = val;
				this.getData();
			},
			resetForm() {
				this.search = {
					cnumber: '',
					cname: '',
					category:[],
					phone: '',
					contactname: '',
					contactphone: '',
					transport: '',
					remark: '',
					valid: '',
					state:'',
				}
			},
			// swapArray(arr, index1, index2) {
			// 	arr[index1] = arr.splice(index2, 1, arr[index1])[0]
			// },
			// up(index) {
			// 	this.swapArray(this.cols, index - 1, index)
			// },
			// down(index) {
			// 	this.swapArray(this.cols, index, index + 1)
			// },
			addCus() {
				if(this.$common.checkLimits("customerAdd")){
					this.addDialog = true;
					this.$nextTick(()=>{
						this.$refs.add.init();
					})
				}
			},
			enableDisable(row) {
				var param = {
					ids: row.id,
					valid: row.valid
				}
				this.$api.customersetCustomerValid(param).then(res => {
				})
			},
			doAction(val){
				if(val==0||val==1){
					this.setValid(val);
				}else if(val==2){
					this.deleteMany();
				}
			},
			setValid(valid) {
				this.$nextTick(() => {
					const selection = this.$refs.multipleTable.selection
					if(selection.length > 0) {
						var ids = []
						selection.map(item => {
							ids.push(item.id)
						})
						var param = {
							ids: ids.toString(),
							valid: valid
						}

						this.$api.customersetCustomerValid(param).then(res => {
							this.$notify({
								title: valid === 1 ? '启用客户' : '禁用客户',
								message: valid === 1 ? '启用成功' : '禁用成功',
								type: 'success',
								duration: 1000,
								onClose: () => {
									this.getData();
								}
							})
						})
					} else {
						this.$notify({
							message: '请选择数据',
							type: 'warning',
							duration: 1000
						})
					}
				})
			},
			deleteMany() {
				if(!this.$common.checkLimits("customerDelete")){
					return;
				}
				this.$nextTick(() => {
					const selection = this.$refs.multipleTable.selection
					if(selection.length > 0) {
						var ids = []
						selection.map(item => {
							ids.push(item.id)
						})

						const confirmText = ['是否删除所选项？', '注意：删除后不可恢复。']
						const newData = []
						const h = this.$createElement
						for(const i in confirmText) {
							newData.push(h('p', null, confirmText[i]))
						}
						this.$confirm('警告', {
							title: '警告',
							message: h('div', null, newData),
							showCancelButton: true,
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							let obj = {
								deleteIds: ids.toString(),
							}
							this.$api.customerdeleteCustomer(obj).then(res => {
								this.$notify({
									title: '删除客户',
									message: '删除成功',
									type: 'success',
									duration: 1000,
									onClose: () => {
										this.searchData()
									}
								})
							})
						}, () => {})
					} else {
						this.$notify({
							message: '请选择数据',
							type: 'warning',
							duration: 1000
						})
					}
				})
			},
			editConfirm() {
				this.$refs.edit.submitForm('addform')
			},
			addClose() {
				this.$refs.add.submitFormClose('addform')
			},
			close() {
				this.addDialog = false;
				this.getData();
			},
			closeEdit() {
				this.editDialog = false;
				this.getData();
			},
		}
	}
</script>